import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import type { SelectLabelProp } from "./system.types";
import { SELECT_DEFAULT_LABEL_PROP } from "src/system/constants.ts";

export const getSelectSearchField = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  searchField,
  labelProp,
}: {
  searchField?: string;
  labelProp?: SelectLabelProp<Resource>;
}) => {
  if (searchField) {
    return searchField;
  }
  if (typeof labelProp === "function") {
    return SELECT_DEFAULT_LABEL_PROP;
  }
  return labelProp ?? SELECT_DEFAULT_LABEL_PROP;
};
